import React from 'react'

const Activity = (props) => {
  return (
    <div className='d-flex flex-column' />
  )
}

export default Activity
